/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Error_UnauthorizedInputs */

const en_backend_session_error_unauthorized = /** @type {(inputs: Backend_Session_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication rejected by the backend. Please sign in again.`)
};

const fr_backend_session_error_unauthorized = /** @type {(inputs: Backend_Session_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification rejetée par le backend. Reconnectez-vous.`)
};

const ms_sg2_backend_session_error_unauthorized = /** @type {(inputs: Backend_Session_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengesahan ditolak oleh backend. Sila log masuk semula.`)
};

/**
* | output |
* | --- |
* | "Authentication rejected by the backend. Please sign in again." |
*
* @param {Backend_Session_Error_UnauthorizedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_unauthorized = /** @type {((inputs?: Backend_Session_Error_UnauthorizedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_UnauthorizedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_unauthorized(inputs)
	if (locale === "fr") return fr_backend_session_error_unauthorized(inputs)
	return ms_sg2_backend_session_error_unauthorized(inputs)
});